import { useSettingEnableLoggedOutDiscoverStoreTypeSection } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableLoggedOutDiscoverStoreTypeSection";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  ITabProps,
  PillWithContent,
} from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/homepage-v2-only/__internal__/PillWithContentComponent/PillWithContent";
import { DiscoverProductCarousel } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/DiscoverProductCarousel";
import { useQuery_escape_hatch as useStoreTypeQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/logged-out/store-type-carousel/post-hooks";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useState } from "react";

import { useSearchPageBrandMap } from "../../../../DataFetching/Products/useSearchPageBrandMap";
import { useSearchPageSlicedProducts } from "../../../useSearchPageSlicedProducts";
import {
  SectionHeader,
  TOP_PRODUCTS_COUNT,
} from "../DiscoverPageSectionalDesign";

export const DiscoverStoreTypeSection: React.FC<{
  query: string;
  loadTimingRef?: React.RefCallback<HTMLElement>;
  isPageWithFilter?: boolean;
  isSectionalDesign?: boolean;
}> = ({ loadTimingRef, query, isPageWithFilter, isSectionalDesign }) => {
  const storeTypeSectionVariant =
    useSettingEnableLoggedOutDiscoverStoreTypeSection();
  const { data: storeTypeCarousel } = useStoreTypeQuery(
    {
      query,
    },
    {
      enabled:
        !!query && storeTypeSectionVariant !== IThreeVariantXP.Bucket.CONTROL,
    }
  );

  const [currentIndex, setCurrentIndex] = useState(0);

  const storeTypes = storeTypeCarousel?.store_types ?? [];

  const tabs: Array<ITabProps> = storeTypes.map((storeType) => ({
    tabName: storeType.store_type_name,
    pathIdentifier: "",
    ctaLink: "",
    ctaLinkText: "",
  }));

  const currentStoreType = storeTypes[currentIndex];
  const currentProducts = currentStoreType?.product_tiles || [];
  const currentBrandMap = currentStoreType?.brand_by_token;

  const products = useSearchPageSlicedProducts();
  const isStoreTypeSectionVariant2 =
    storeTypeSectionVariant === IThreeVariantXP.Bucket.VARIANT_2;
  const topProducts = products?.slice(0, TOP_PRODUCTS_COUNT) ?? [];

  const brandMap = useSearchPageBrandMap();

  if (
    !storeTypes.length ||
    !currentStoreType ||
    !storeTypeCarousel?.title ||
    storeTypeSectionVariant === IThreeVariantXP.Bucket.CONTROL
  ) {
    return null;
  }

  return (
    <Column
      gap={{
        mobileAndAbove: "2x",
        desktopAndAbove: "3x",
      }}
      className="w-full pt-4 md:pt-6"
    >
      {isStoreTypeSectionVariant2 && !isSectionalDesign ? (
        <>
          <SectionHeader>
            <StrictLocalMsg
              id="wDNsLZ"
              defaultMessage="Top {queryFullyTranslatedSentence} products"
              values={{ queryFullyTranslatedSentence: query }}
              description={{
                text: "Header for a product line",
                img: "https://cdn.faire.com/fastly/64f56536549126e54f02232488f54398578b4c2030b029938da5b27a8cab41b7.png",
              }}
            />
          </SectionHeader>
          <div className="w-inherit md:px-2">
            <DiscoverProductCarousel
              products={topProducts}
              brandMap={brandMap}
              isPageWithFilter={isPageWithFilter}
              requestId={storeTypeCarousel?.request_id}
            />
          </div>
        </>
      ) : null}
      <PillWithContent
        title={storeTypeCarousel?.title}
        tabs={tabs}
        eventTrackingName="discover_store_section_banner"
        loadTimingRef={loadTimingRef}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        pauseScroll={() => {}}
        resumeScroll={() => {}}
        className="mx-0! my-0!"
        childrenClassName="pr-0!"
        titleClassName="ml-2!"
        titleSizeResponsive={{
          mobileAndAbove: "pageHeaderSerifRegular",
          tabletAndAbove: "displaySSerifRegular",
        }}
        isAnimated={false}
        isVisible
      >
        <div className="w-inherit md:px-2">
          <Spacer height="3x" />
          <DiscoverProductCarousel
            products={currentProducts}
            brandMap={currentBrandMap}
            isPageWithFilter={isPageWithFilter}
            requestId={storeTypeCarousel?.request_id}
          />
        </div>
      </PillWithContent>
      {isSectionalDesign ? (
        <Spacer height="1x" />
      ) : (
        <SectionHeader>
          <StrictLocalMsg
            id="abAZiC"
            defaultMessage="All products related to {queryFullyTranslatedSentence}"
            values={{ queryFullyTranslatedSentence: query }}
            description={{
              text: "Header for a product grid",
              img: "https://cdn.faire.com/fastly/64f56536549126e54f02232488f54398578b4c2030b029938da5b27a8cab41b7.png",
            }}
          />
        </SectionHeader>
      )}
    </Column>
  );
};
